import {Component, OnInit} from '@angular/core';
import {map} from 'rxjs/operators';
import {ClientRepresentation} from '../../../../models/ClientRepresentation';
import {OAuthService} from '../../../../services/o-auth.service';
import {UserService} from '../../../../services/user.service';
import {UserRepresentation} from '../../../../models/UserRepresentation';
import {ConfigService} from '../../../../services/config.service';

@Component({
    selector: 'mb-app-menu',
    templateUrl: './app-menu.component.html',
    styleUrls: ['./app-menu.component.scss']
})
export class AppMenuComponent implements OnInit {

    loggedUser: UserRepresentation;
    appPortal: ClientRepresentation;
    applications: ClientRepresentation[];

    constructor(private userService: UserService,
                private oauthService: OAuthService,
                private appConfig: ConfigService) {
        this.appPortal = this.appConfig.appPortal;
    }

    goToApplication(app: ClientRepresentation): void {
        window.location.href = window.location.protocol + '//' + window.location.host + (app.baseUrl || '');
    }

    getAppPhoto(app: any): string {
        return app.attributes ? app.attributes['icon'] : 'assets/images/applications/mobit.png';
    }

    async ngOnInit(): Promise<void> {
        this.loggedUser = await this.userService.getLoggedUser();
        this.applications = await this.oauthService.findAllApplications().pipe(
            map(apps => apps.filter(this.appFilter))
        ).toPromise();
    }

    private appFilter = (app: any) =>
        this.loggedUser.attributes['aplicacoes'].includes(app.id) && app.id !== this.appConfig.clientId
}